export const SET_IS_NETWORK = "SET_IS_NETWORK";

export const setIsNetwork = (value) => (dispatch) => {
    dispatch({type: SET_IS_NETWORK, payload: value});
};